import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import Select from 'components/select';
import { sspSubmitOrder } from 'pages/provisioning/store/couchbase';
import ProvisioningStyles from 'pages/provisioning/couchbase/style';
import HelpImg from 'pages/provisioning/_components/helpImg';

const BusinessCategory = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const businessCategoryApi = useMutation(() => axios.get(endPoints.aws.lookups.awsBusinessCategory));

    const isExistsInOptions = (businessCategory) => options.find((option) => businessCategory === option.value);

    const handleOnSelectChange = (selected) => {
        setOrder({ ...order, businessCategory: selected.value });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    React.useEffect(() => {
        if (businessCategoryApi?.isSuccess && businessCategoryApi?.data?.data) {
            const opts = businessCategoryApi?.data?.data?.map((category) => ({
                label: category,
                value: category,
            }));
            setOptions(opts);
        }
    }, [businessCategoryApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.businessCategory) {
            setOrder({ ...order, businessCategory: options?.[0].value });
        }
        if (options && options?.length && order?.businessCategory) {
            const businessCategory = isExistsInOptions(order?.businessCategory);
            if (businessCategory) {
                setOrder({ ...order, businessCategory: businessCategory?.value });
            }
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        businessCategoryApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!order?.businessCategory && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.businessCategory, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Box sx={ProvisioningStyles.box} flex={1}>
                <Select
                    dataTestId="business-category-autocomplete"
                    key="businessCategory"
                    label="Business Category *"
                    value={order?.businessCategory || null}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value)}
                    disabled={businessCategoryApi.isLoading}
                    isLoading={businessCategoryApi.isLoading}
                    isRequired={isTouched}
                />
            </Box>
            <HelpImg
                title={
                    <Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography>
                                    <span style={{ fontWeight: 600 }}>Business Category Options:</span>
                                </Typography>
                                <Stack>
                                    <Typography>• make = Manufacturing</Typography>
                                    <Typography>• move = Product Movement</Typography>
                                    <Typography>• sell = Selling Production</Typography>
                                    <Typography>• all = Including All Options</Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                }
            />
        </Box>
    );
};

export default React.memo(BusinessCategory);
